interface Props {
  onClick: () => void;
}
const SvgModalClose: React.FC<Props> = ({ onClick }) => {
  return (
    <svg onClick={onClick} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 0C4.477 0 0 4.477 0 10C0 15.523 4.477 20 10 20C15.523 20 20 15.523 20 10C20 4.477 15.523 0 10 0ZM13.7805 12.7195C14.0735 13.0125 14.0735 13.487 13.7805 13.78C13.634 13.927 13.442 14 13.25 14C13.058 14 12.866 13.927 12.7195 13.7805L10 11.0605L7.2805 13.78C7.134 13.927 6.942 14 6.75 14C6.558 14 6.366 13.927 6.2195 13.7805C5.9265 13.4875 5.9265 13.013 6.2195 12.72L8.9395 10L6.22 7.2805C5.927 6.9875 5.927 6.513 6.22 6.22C6.513 5.927 6.9875 5.927 7.2805 6.22L10 8.9395L12.7195 6.22C13.0125 5.927 13.487 5.927 13.78 6.22C14.073 6.513 14.073 6.9875 13.78 7.2805L11.0605 10L13.7805 12.7195Z"
        fill="#E2E2E2"
      />
    </svg>
  );
};

export default SvgModalClose;
